export default {
  meta: {
    title: $localize`:@@meta.defuse.title:Defuse CS2 CSFAIL - Дефьюз CSGO на скины`,
    description: $localize`:@@meta.defuse.desc:Испытайте свои навыки разминирования в игре CS2 на CSFAIL. Участвуйте в захватывающих миссиях, выигрывайте ценные призы и наслаждайтесь азартом.`
  }
};